import React from "react";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

import { useTheme } from "../../../../hooks/theme";
import CartaoGrafico, { CORES } from "./CartaoGrafico";
import useResumoDespacho from "./useResumoDespacho";

// Top 5 motivos de falha de etiqueta (PO1-3494): barras horizontais com o texto
// do erro devolvido pela transportadora (`motivosFalha`, já ordenado pela API).

const MAX_TEXTO = 48;
const curto = (texto) => {
  const t = String(texto || "Sem motivo informado");
  return t.length > MAX_TEXTO ? `${t.slice(0, MAX_TEXTO - 1)}…` : t;
};

export default function ChartMotivosFalha({ deferLoad = false, onRegisterFetch }) {
  const { darkMode } = useTheme();
  const { dados, carregando, erro } = useResumoDespacho({ deferLoad, onRegisterFetch });
  const cor = darkMode ? "#e9ecef" : "#1e1e2f";
  const linhas = dados ? dados.motivosFalha.map((m) => ({ ...m, rotulo: curto(m.erro) })) : [];

  return (
    <CartaoGrafico titulo="Motivos de falha" subtitulo="Os 5 erros mais frequentes na emissão de etiquetas" carregando={carregando} erro={erro} vazio={!linhas.length} textoVazio="Nenhuma falha no período.">
      <ResponsiveContainer width="100%" height={250}>
        <BarChart data={linhas} layout="vertical" margin={{ top: 10, right: 30, left: 10, bottom: 10 }}>
          <CartesianGrid stroke="rgba(253,93,147, 0.1)" strokeWidth={1} />
          <XAxis type="number" stroke={cor} style={{ fontWeight: 100 }} allowDecimals={false} />
          <YAxis type="category" dataKey="rotulo" width={220} stroke={cor} style={{ fontWeight: 100, fontSize: 11 }} />
          <Tooltip contentStyle={{ background: darkMode ? "#1e1e2f" : "#fff", border: "none" }} formatter={(v) => [v, "Falhas"]} labelFormatter={(_, payload) => (payload && payload[0] ? payload[0].payload.erro : "")} />
          <Bar name="Falhas" dataKey="qtd" fill={CORES.falhas} />
        </BarChart>
      </ResponsiveContainer>
    </CartaoGrafico>
  );
}
